module.exports = __webpack_public_path__ + "img/3.3bb032a5.svg";